<template>
  <v-row class="mt-0 pt-0 mb-16">
    <v-col
      cols="12"
      class="mt-0 pt-0 mb-0 pb-0"
      v-for="(item, index) in bannerItems"
      :key="index"
    >
      <v-img
        id="intro"
        :src="getBannerImage(item.rol)"
        class="shrink align-end mx-0 px-0"
        width="100%"
        height="100%"
      >
        <v-row class="justify-end text-end mx-5 mb-sm-9 mb-md-9 mb-lg-16" width="100%">
          <v-col cols="auto" class="mb-lg-16">
            <div class="primary--text text--darken-4 text-h4 justify-end">
              {{ item.title }}
            </div>
            <div class="primary--text text-body-2 justify-end mb-7">
              {{ item.subtitle }}
            </div>
          </v-col>
        </v-row>
      </v-img>
      <v-carousel-uses :platUses="item.uses" class="mt-md-n3" />
    </v-col>
  </v-row>
</template>

<script>
import bannerPro from '@/assets/BannerHomePro.webp';
import bannerPat from '@/assets/BannerHomePat.webp';
import VCarouselUses from '@/components/base/VCarouselUses.vue';

export default {
  name: 'HomeBanner',
  components: {
    VCarouselUses,
  },
  props: ['bannerItems'],
  methods: {
    getBannerImage(rol) {
      return rol === 'pro' ? bannerPro : bannerPat;
    },
  },
};
</script>
